import { render, staticRenderFns } from "./modal_source.vue?vue&type=template&id=36b2818e&scoped=true&"
import script from "./modal_source.vue?vue&type=script&lang=js&"
export * from "./modal_source.vue?vue&type=script&lang=js&"
import style0 from "./modal_source.vue?vue&type=style&index=0&id=36b2818e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b2818e",
  null
  
)

export default component.exports